module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/resort_wedding-d3a9c8c9bb5bcadb62ac43785ff99262.svg";